import React, { useState, useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import ConfirmIconButton from "components/ConfirmIconButton";
import { getManifestLiveVariation } from "utils/mapStateToProps";
import { useCtxReferences, useManifest } from "utils/selectors";
import Analytics, { DELETE_MANIFEST } from "utils/analytics";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteManifest } from "actions/manifest";

const KEYWORD = "delete";

const ManifestDestroyButton = ({ uuid, actions, afterDestroy }) => {
  const manifest = useManifest(uuid, "uuid");
  const [value, setValue] = useState("");
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    const comparison = value.toLowerCase();
    const keywordMatch = comparison === KEYWORD;
    const shouldEnable = keywordMatch && disabled;
    const shouldDisable = !keywordMatch && !disabled;
    if (shouldEnable) {
      setDisabled(false);
    } else if (shouldDisable) {
      setDisabled(true);
    }
  }, [value]);

  const inputProps = {
    className:
      "f5 border-box input-reset ba pa2 db w-100 br2 lh-copy b--black-20",
    type: "text",
    name: "text",
    onChange: (evt) => {
      setValue(evt.currentTarget.value);
    },
    value,
    ...AUTO_ATTRS,
    placeholder: ""
  };

  const {
    application,
    resource,
    resourceUUID,
    resourceID
  } = useCtxReferences();
  const liveVariation = getManifestLiveVariation({
    id: manifest && manifest.id,
    application
  });

  const deleteManifest = (cb) => {
    Analytics.track(DELETE_MANIFEST, {
      uuid,
      resource,
      resource_uuid: resourceUUID,
      is_live: !isEmpty(liveVariation)
    });

    actions.deleteManifest(
      {
        resourceUUID,
        resourceID,
        resource,
        uuid
      },
      (err, response) => {
        cb && cb(err, response);
        afterDestroy && afterDestroy();
      }
    );
  };
  const keywordPrompt = `Type "${KEYWORD}" to confirm.`;

  const slides = [
    {
      title: liveVariation ? "Turn off in production" : "Delete page",
      header: liveVariation
        ? "This page is currently live in production. Deleting it will turn off the live page it's associated with."
        : "Are you sure you want to delete this page?",
      subheader: liveVariation
        ? `Your visitors will no longer be able to see this page at ${liveVariation.route}, until you publish another page as it's replacement. Are you sure you want to do this? ${keywordPrompt}`
        : keywordPrompt,
      children: (
        <div className="w-100 pb3">
          <input {...inputProps} />
        </div>
      )
    }
  ];

  return (
    <ConfirmIconButton
      onCancel={() => setValue("")}
      confirmDisabled={disabled}
      slides={slides}
      tooltip=" "
      onConfirm={deleteManifest}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      deleteManifest
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ManifestDestroyButton);
